import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import TableCDS from '@sharedCR/coreDesignSystem/Table/TableCDS';
import PropTypes from 'prop-types';

import { sectionStyles, sectionTitleStyles } from '../../DrawReviewDrawer.styles';
import { DrawReviewDrawerTestIds } from '../../DrawReviewDrawer.testIds';
import { getClearedChecklistCount } from '../../DrawReviewDrawer.utils';

import { getChecklistConfig } from './DrawChecklistSection.config';

const DrawChecklistSection = ({ checklistItems }) => {
  const config = useMemo(() => getChecklistConfig(), []);
  const clearedCount = getClearedChecklistCount(checklistItems);

  return (
    <Box data-testid={DrawReviewDrawerTestIds.CHECKLIST_SECTION} sx={sectionStyles}>
      <Typography sx={sectionTitleStyles} variant="bold12">
        {`Required Items — draw checklist · ${clearedCount} of ${checklistItems.length} cleared`}
      </Typography>
      <TableCDS config={config} data={checklistItems} title="" />
    </Box>
  );
};

DrawChecklistSection.propTypes = {
  checklistItems: PropTypes.array.isRequired,
};

export default memo(DrawChecklistSection);
